import { observer } from 'mobx-react';
import { useStore } from '../../../core/utils/hook';
import moment from 'moment';
import { DATE_YMD, MSG, SCREEN_MODE } from '../../../core/configs/constants';
import { useEffect, useState } from 'react';

import './styles.scss';
import { flowResult } from 'mobx';
import { ReactNotifications } from '../../../components';
import yup from '../../../core/utils/yupValidate';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import classNames from 'classnames';



const SettingReportModal = observer(({ id, name, deadline, mode, reportContent, reportMaxLength, fetchData, readOnly }) => {
    // validate form
    const validateSchema = yup.object().shape({
        reportContent: yup.string().required(MSG['error.required'])
            
    })
    const REPORT_MAX_CHARACTER = reportMaxLength || 1000;

    const { setValue, getValues, handleSubmit, formState: { errors, isSubmitting }, reset } = useForm({
        resolver: yupResolver(validateSchema),
        mode: 'onChange',
        defaultValues: {
            reportContent: ''
        }
    });
    const [lengthReport, setLengthReport] = useState(0);

    // store
    const {
        modalStore: { hide },
   
        courseStore: { submitTrainingCourseReport }
    } = useStore();

    // lifecycle
    useEffect(() => {
        if ((mode === SCREEN_MODE.EDIT || mode === SCREEN_MODE.VIEW) && reportContent) {
            reset({ reportContent: reportContent })
        }
        setLengthReport(getValues('reportContent')?.length || 0);
    }, [mode, reportContent])

    // function
    const handleChange = (event) => {
        const { name, value } = event.target;
        setValue(name, value);
        if (name === 'reportContent') {
            setLengthReport(value.length);
        }
    };

    const onSubmit = async (data) => {
        try {
            const { reportContent } = data;
            const result = await flowResult(submitTrainingCourseReport(id, { reportContent: reportContent }));
    
            
            if (result) {
                fetchData && fetchData();
                ReactNotifications('success', MSG['inform.success.update']);
                hide();
            }
           
        } catch (err) {
            console.error('Error in onSubmit:', err);
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className='setting-report-modal'>
            <div className='pd-20'>
                <div className='row'>
                    <div className='col-3' style={{color: '#6F6F6F', fontWeight: 500, fontSize: '16px'}}>講座名</div>
                    <div className='col-9' style={{color: '#000000', fontWeight: 600, fontSize: '15px'}}>{name}</div>
                </div>
                <div className='row mg-t-10'>
                    <div className='col-3' style={{color: '#6F6F6F', fontWeight: 500, fontSize: '16px'}}>提出期限</div>
                    <div className='col-9' style={{color: '#000000', fontWeight: 600, fontSize: '15px'}}>{moment(deadline).format(DATE_YMD)}</div>
                </div>
                <div className='row mg-t-10' >
                    <div className='col-3 d-flex align-items-center flex-gap-5' style={{color: '#6F6F6F', fontWeight: 500, fontSize: '16px'}}>
                        レポート内容
                        <div style={{color: '#F60004'}}>*</div>
                    </div>
                    <div className={classNames('', readOnly && 'disabled')} >
                        <div className='row mg-0'>
                            <textarea
                                disabled={readOnly}
                                cols={30} rows={10}
                                name='reportContent'
                                style={{border: '1px solid #D7D7D7', borderRadius: '5px'}}
                                className=''
                                maxLength={REPORT_MAX_CHARACTER}
                                onChange={handleChange}
                                value={getValues('reportContent')}
                            />
                        </div>
                        <div style={{display: 'flex', justifyContent: 'flex-end', fontSize: '14px', color: '#6F6F6F'}}>
                            <span>
                                入力可能な最大文字数: {lengthReport}/{REPORT_MAX_CHARACTER}
                            </span>
                        </div>
                    </div>
                </div>
               
                <div className='row'>
                    <div className='col-3'></div>
                    <div className='col-9'>
                        {
                            errors?.reportContent && (
                                <div className='text-danger mg-t-5'>{errors.reportContent?.message}</div>
                            )
                        }
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center align-items-center flex-gap-30 pd-tb-10'
                style={{ borderTop: '1px solid #d3d3d3' }}>
                <button 
                    type='button' 
                    className='btn btn-cancel-1'
                    style={{
                        minWidth: '120px',
                        borderRadius: '5px',
                        height: '40px'
                    }}
                    onClick={() => hide()}>キャンセル

                </button>
                {
                    mode !== SCREEN_MODE.VIEW &&
                    <button 
                        type='submit'
                        disabled={isSubmitting || getValues('reportContent')?.length === 0 || readOnly}
                        className='btn btn-default-4' 
                        style={{
                            minWidth: '120px',
                            borderRadius: '5px',
                            height: '40px'
                        }}>
                        提出
                    </button>
                }
            </div>
            
        </form>
    )
});

export default SettingReportModal;